
import { useState } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { ActivitySearch } from "@/components/activities/ActivitySearch";
import { ActivityFilters } from "@/components/activities/ActivityFilters";
import { ActivityStats } from "@/components/activities/ActivityStats";
import { ActivitiesHeader } from "@/components/activities/ActivitiesHeader";
import { PrintableActivitiesSection } from "@/components/activities/PrintableActivitiesSection";
import { OnlineActivitiesSection } from "@/components/activities/OnlineActivitiesSection";
import { ParentTipsSection } from "@/components/activities/ParentTipsSection";
import { ActivitiesCTA } from "@/components/activities/ActivitiesCTA";
import { SocialMediaHead } from "@/components/shared/SocialMediaHead";
import { useActivitiesData } from "@/hooks/useActivitiesData";
import { usePagination } from "@/hooks/usePagination";

const Activities = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedDifficulty, setSelectedDifficulty] = useState("");
  const [selectedAgeGroup, setSelectedAgeGroup] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(12);

  const { activities, categories, ageGroups, difficultyLevels, loading, stats } = useActivitiesData({
    searchTerm,
    selectedCategory,
    selectedDifficulty,
    selectedAgeGroup,
  });

  const {
    currentPage,
    totalPages,
    paginatedItems: paginatedActivities,
    goToPage,
    resetPagination,
  } = usePagination({
    items: activities,
    itemsPerPage,
  });

  const handleResetFilters = () => {
    setSearchTerm("");
    setSelectedCategory("");
    setSelectedDifficulty("");
    setSelectedAgeGroup("");
    resetPagination();
  };

  const handleItemsPerPageChange = (newItemsPerPage: number) => {
    setItemsPerPage(newItemsPerPage);
    resetPagination();
  };

  return (
    <>
      <SocialMediaHead page="activities" />
      <Navbar />
      <div className="min-h-screen bg-gradient-to-br from-sky-blue/20 via-white to-bobo-green/20">
        <ActivitiesHeader />

        <ActivityStats 
          totalActivities={stats.totalActivities}
          publishedActivities={stats.publishedActivities}
          categoriesCount={stats.categoriesCount}
          loading={loading}
        />

        <PrintableActivitiesSection
          loading={loading}
          paginatedActivities={paginatedActivities}
          currentPage={currentPage}
          totalPages={totalPages}
          itemsPerPage={itemsPerPage}
          totalItems={activities.length}
          onPageChange={goToPage}
          onItemsPerPageChange={handleItemsPerPageChange}
          onResetFilters={handleResetFilters}
          searchComponent={
            <ActivitySearch
              value={searchTerm}
              onChange={setSearchTerm}
              placeholder="Search activities by title or description..."
            />
          }
          filtersComponent={
            <ActivityFilters
              categories={categories}
              ageGroups={ageGroups}
              difficultyLevels={difficultyLevels}
              selectedCategory={selectedCategory}
              selectedDifficulty={selectedDifficulty}
              selectedAgeGroup={selectedAgeGroup}
              onCategoryChange={setSelectedCategory}
              onDifficultyChange={setSelectedDifficulty}
              onAgeGroupChange={setSelectedAgeGroup}
              onReset={handleResetFilters}
            />
          }
        />

        <OnlineActivitiesSection />

        <ParentTipsSection />

        <ActivitiesCTA />
      </div>
      <Footer />
    </>
  );
};

export default Activities;
